import baseAPI from '@/api/base';
import { GenerateReportParams, ReportFacetsParams, ReportsParams } from '@/dtos/reports.dto';
import {
  GENERATE_REPORT_URL,
  GET_EMPLOYEE_REPORTS_URL,
  GET_PAYROLL_REPORTS_URL,
  GET_PROJECT_REPORTS_URL,
  GET_REPORT_FACETS_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Reports {
  static getEmployeeReports = async (params: ReportsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_REPORTS_URL, {
      params,
    });
    return response;
  };

  static getPayrollReports = async (params: ReportsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_REPORTS_URL, {
      params,
    });
    return response;
  };

  static getProjectReports = async (params: ReportsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_REPORTS_URL, {
      params,
    });
    return response;
  };

  static getReportFacets = async (params: ReportFacetsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_REPORT_FACETS_URL, { params });
    return response;
  };

  static generateReport = async (params: GenerateReportParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GENERATE_REPORT_URL, { params });
    return response;
  };

  static exportReport = async (params: GenerateReportParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GENERATE_REPORT_URL, { params: { ...params, format: 'csv' }, responseType: 'blob' });
    return response;
  };
}

export default Reports;
